import { useEffect, useRef } from "react";
import { useArticles } from "../../../hooks/useArticles";

export default function NewsTicker() {
  const { articles } = useArticles();
  const tickerRef = useRef<HTMLDivElement>(null);

  const tickerItems = articles.length > 0
    ? articles.slice(0, 7).map((a) => `✈️ ${a.title}`)
    : ["✈️ Próximamente noticias del sector aeronáutico dominicano"];

  useEffect(() => {
    const el = tickerRef.current;
    if (!el) return;
    let pos = 0;
    const speed = 0.5;
    const animate = () => {
      pos -= speed;
      if (Math.abs(pos) >= el.scrollWidth / 2) {
        pos = 0;
      }
      el.style.transform = `translateX(${pos}px)`;
      requestAnimationFrame(animate);
    };
    const frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [tickerItems.length]);

  const doubled = [...tickerItems, ...tickerItems];

  return (
    <div className="bg-[#0B1F3A] py-2.5 overflow-hidden border-b border-blue-900/50">
      <div className="flex items-center">
        <div className="flex-shrink-0 bg-blue-600 px-4 py-1 mr-4 z-10">
          <span className="text-white text-xs font-inter font-bold tracking-widest uppercase whitespace-nowrap">
            ÚLTIMA HORA
          </span>
        </div>
        <div className="overflow-hidden flex-1 relative">
          <div ref={tickerRef} className="flex gap-12 whitespace-nowrap">
            {doubled.map((item, i) => (
              <span key={i} className="text-blue-100/80 text-xs font-inter flex-shrink-0 cursor-default">
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}